module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-build-issue-17.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/vux-build-issue.md
// module id = 594
// module chunks = 201